import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

const MapSelector = ({ onLocationSelect, currentLocation }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedLocationName, setSelectedLocationName] = useState("");
  const [showMap, setShowMap] = useState(false);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_Maps_API_KEY,
  });

  const handleMapClick = async (lat, lng) => {
    const location = `${lat},${lng}`;
    setSelectedLocation(location);

    // Reverse geocode to get the location name
    try {
      const geocodeResponse = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_Maps_API_KEY}`
      );
      const geocodeData = await geocodeResponse.json();
      if (geocodeData.results && geocodeData.results.length > 0) {
        setSelectedLocationName(geocodeData.results[0].formatted_address);
        onLocationSelect(location, geocodeData.results[0].formatted_address);
      } else {
        setSelectedLocationName("Unknown Location");
        onLocationSelect(location, "Unknown Location");
      }
    } catch (error) {
      console.error("Error reverse geocoding location:", error);
      setSelectedLocationName("Unknown Location");
      onLocationSelect(location, "Unknown Location");
    }

    setShowMap(false); // Hide the map after selecting a location
  };

  return (
    <Box>
      {/* Toggle Map Button */}
      <Button
        variant="contained"
        onClick={() => setShowMap((prev) => !prev)}
        sx={{ textTransform: "none" }}
      >
        {showMap ? "Hide Map" : "Select Location"}
      </Button>

      {/* Map Picker */}
      {showMap && isLoaded && (
        <Box mt={2} sx={{ height: "400px", width: "100%" }}>
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "100%" }}
            center={currentLocation || { lat: -34.397, lng: 150.644 }}
            zoom={8}
            onClick={(e) => handleMapClick(e.latLng.lat(), e.latLng.lng())}
          >
            {currentLocation && (
              <Marker position={currentLocation} label="You are here" />
            )}
            {selectedLocation && (
              <Marker
                position={{
                  lat: parseFloat(selectedLocation.split(",")[0]),
                  lng: parseFloat(selectedLocation.split(",")[1]),
                }}
              />
            )}
          </GoogleMap>
        </Box>
      )}

      {/* Display Selected Location */}
      {selectedLocationName && (
        <Typography mt={2} variant="body1">
          Selected Location: {selectedLocationName}
        </Typography>
      )}
    </Box>
  );
};

export default MapSelector;